import {
  IcBrowserWallet,
  IcMetamaskWallet,
  IcWalletConnect,
} from "~/src/assets/icon";
import { AvacusLogoMobile } from "~/src/assets/img";

export const baseSignMessage =
  "Hi there from Avacus Wallet! Please sign this message to prove that you can access to secure chat. To stop hackers access to your secure chat, do not sign this message outside Avacus Wallet, and here's a unique message ID they can't guess: ";
export const baseSignMessageCTN =
  "Hi there from Avacus Connect! Please sign this message to prove that you can access our service. For security reasons, do not sign this message outside Avacus Connect, and here's a unique message ID they can't guess: ";

export const AVACUS_DEEP_LINK = "https://avacus.app.link";
export const addressShorten: any = (address: string, num: number) => {
  if (!address) return "";
  if (!num) num = 6;
  if (num >= address.length / 2) return address;
  const prefix = address?.slice(0, num);
  const suffix = address?.slice(-num, address.length);
  return `${prefix}···${suffix}`;
};

export const checkValidAddress: any = (address: string) => {
  if (!address || address?.length !== 42) return false;
  else return true;
};

export const displayNameShorten: any = (displayName: string, num = 12) => {
  if (!displayName) return null;
  if (displayName.length <= num) return displayName;
  const prefix = displayName.slice(0, num - 1);
  return `${prefix}...`;
};

export const WalletIcon: Record<string, string> = {
  injected: IcBrowserWallet,
  walletConnect: IcWalletConnect,
  "io.metamask": IcMetamaskWallet,
  "avacus.app": AvacusLogoMobile,
};
